import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/api/ConferenceApi/" );

/* eslint-disable arrow-body-style */

/**
 * Submit the booking
 */
export const submitBooking = ( data ) => {
  return instance.post( "SubmitBooking", null, data );
};

/**
 * Book a conference
 * @param {String} instanceId The ID of the instance for the conference we are booking
 * @param {Array} productsToBook A list of order lines to add for the conference booking
 * @param {Number} freeProductId The ID of the product to use when adding free places (if any)
 * @param {Number} freeSpaces The number of free spaces to allocate
 */
export const bookConference = ( instanceId, productsToBook, freeProductId, freeSpaces ) => {
  return instance.post( "Book", {
    instanceId,
    freeProductId,
    productsToBook,
    freeSpaces,
  } );
};

/**
 * Abandon a booked conference
 * @param {Array} orderLineIds An array of order line IDs for the booked conference
 */
export const abandonConference = ( orderLineIds ) => {
  return instance.post( "Abandon", orderLineIds );
};
